import React from 'react';
import { useDispatch } from 'react-redux';
import { loginModalDispatch } from '../../ducks/Auth.duck';
import { Modal } from '../../components';
import AuthenticationPage from '../../containers/AuthenticationPage/AuthenticationPage';
import css from './Topbar.module.css';

export default function SignupModal({ currentState, data, onDismiss }) {
  const dispatch = useDispatch();
  const onManageDisableScrolling = (componentId, scrollingDisabled = true) => {
    console.log('Toggling Modal - scrollingDisabled currently:', componentId, scrollingDisabled);
  };
  const [signupModal, setSignupModal] = React.useState(true);

  const closeSignup = () => {
    if (data) {
      data(false);
    } else {
      setSignupModal(false);
    }
  };

  // "Already have an account? Sign in": open the login modal that lives in the
  // Topbar instead of only closing this one and exposing the page underneath.
  const handleSwitchToLogin = () => {
    closeSignup();
    dispatch(loginModalDispatch({ loginModal: true }));
  };

  const handleDismiss = () => {
    if (onDismiss) {
      onDismiss();
    }
    closeSignup();
  };

  return (
    <Modal
      isAuth={true}
      className={css.modalStyle}
      id="AuthenticationPageSignUp.tos"
      isOpen={currentState || signupModal}
      onClose={handleDismiss}
      usePortal
      onManageDisableScrolling={onManageDisableScrolling}
    >
      <AuthenticationPage type="signup" onSwitchToLogin={handleSwitchToLogin} />
    </Modal>
  );
}
